export default __webpack_public_path__ + "static/media/470.f97c6c55.png";